<template>
    <div class="app-container">
        <div class="top-btn">
            <vxe-button status="success" @click="returnToLevel">返回</vxe-button>
        </div>
        <div class="table-container">
          <table>
            <!-- 第一行 -->
            <tr>
              <th style="width:130px">经销单位：</th>
              <td class="white-background">{{ form.org_id_text}}</td>
              <th style="width:120px">活动类型：</th>
              <td style="width:120px" class="white-background">{{ form.hd_type_text }}</td>
              <th style="width:120px">参加人数：</th>
              <td style="width:120px" class="white-background">{{ form.customer_num }}人</td>
              <td colspan="5" style="width:440px">
                <a-button type="link">活动开展申请表</a-button> 
              </td>
              <th colspan="2" class="white-background">申请时间：{{ form.cdate }}</th>
            </tr>
      
            <!-- 第二行 - 费用说明 -->
            <tr>
              <th rowspan="3">费用支出明细：</th>
              <td>支出项目：</td>
              <td>油费（柴油）</td>
              <td>过桥过路费</td>
              <td>会务费</td>
              <td>布展费</td>
              <td>场地租金</td>
              <td>记者劳务费</td>
              <td>礼品费</td>
              <td>车辆保险</td>
              <td>其他费用</td>
              <td>支出合计</td>
              <td>柳汽报销费用</td>
            </tr>
            
            <!-- 第三行 - 支出明细 -->
            <tr>
              <td>支出费用：</td>
              <td>{{ form.yf }}</td>
              <td>{{ form.gqglf }}</td>
              <td>{{ form.hwf }}</td>
              <td>{{ form.bzf}}</td>
              <td>{{ form.cdzj}}</td>
              <td>{{ form.jzlwf}}</td>
              <td>{{ form.lpf}}</td>
              <td>{{ form.clbx}}</td>
              <td>{{ form.qtfy }}</td>
              <td>{{ form.qtfy}}</td>
              <td rowspan="2">{{ form.lq_price }}</td>
            </tr>
            <tr>
                <td>审核费用：</td>
                <td>{{ form.yf_audit }}</td>
                <td>{{ form.gqglf_audit }}</td>
                <td>{{ form.hwf_audit }}</td>
                <td>{{ form.bzf_audit}}</td>
                <td>{{ form.cdzj_audit}}</td>
                <td>{{ form.jzlwf_audit}}</td>
                <td>{{ form.lpf_audit}}</td>
                <td>{{ form.clbx_audit}}</td>
                <td>{{ form.qtfy_audit }}</td>
                <td>{{ form.qtfy_audit}}</td>
              </tr>
      
            <!-- 报账资料行 -->
            <tr>
              <td colspan="2">报账资料：</td>
              <td colspan="11">上传附件文件</td>
              <!-- <td colspan="6">备注</td> -->
            </tr>
      
            <!-- 活动总结行 -->
            <tr>
              <td colspan="2" class="align-right">活动总结：</td>
              <td colspan="11"><a-button type="link">{{ form.hdzj }}</a-button></td>
              <!-- <td colspan="6"></td> -->
            </tr>
      
            <!-- 活动照片行 -->
            <tr>
              <td colspan="2" class="align-right">活动照片：</td>
              <td colspan="11"><a-button type="link">{{ form.hdzp }}</a-button></td>
              <!-- <td colspan="6"></td> -->
            </tr>
      
            <!-- 签到表原件行 -->
            <tr>
              <td colspan="2" class="align-right">签到表原件：</td>
              <td colspan="11"><a-button type="link">{{ form.qdbyj }}</a-button></td>
              <!-- <td colspan="6"></td> -->
            </tr>
      
            <!-- 发票行 -->
            <tr>
              <td colspan="2" class="align-right">发票：</td>
              <td colspan="11"><a-button type="link">{{ form.fp }}</a-button></td>
              <!-- <td colspan="6"></td> -->
            </tr>
      
            <!-- 产品展示情况表行 -->
            <tr>
              <td colspan="2" class="align-right">产品展示情况表：</td>
              <td colspan="16"><a-button type="link">{{ form.ddzsqk }}</a-button></td>
              <!-- <td colspan="6"></td> -->
            </tr>
      
            <!-- 参加活动客户明细行 -->
            <tr>
              <td colspan="18">
                <a-button type="link">参加活动客户明细</a-button>
              </td>
            </tr>
          </table>
        </div>
        <div style="margin-top:30px">
            <vxe-table  
            :loading="listLoading"
            border
            resizable
            height="300"
            :align="allAlign"
            :data="tableData">
                <vxe-table-column type="seq" width="60" title="序号"></vxe-table-column>
                <vxe-table-column field="user_name" width="200" title="审核人"></vxe-table-column>
                <vxe-table-column field="audit_time"  width="200" title="审核日期"></vxe-table-column>
                <vxe-column field="audit_idear" title="意见">
                  <template #default="{ row }">
                    <div v-html="row.audit_idear"></div>
                  </template>
                </vxe-column>
                <vxe-table-column field="status_name"  width="100" title="状态"></vxe-table-column>
            </vxe-table>
            <div class="note">
              注：标有 * 的标识为必填项
            </div>
        </div>
    </div>
  </template>
  
  <script>
  import { findByIdBaoZhangDetails } from '@/api/activityCustomer'
  export default {
    name: 'ExpenseTable',
    data() {
      return {
        form: {
          
        },
        // 表格数据
        tableData: [],
        allAlign: 'center',
        org_ID:'',
      }
    },
    created() {
      // this.org_ID = '67' 
      this.org_ID = this.$route.query.id
      if (this.$route.query.id) {
        this.queryByPage()
      }
    },
    methods: {
      // 搜索表格数据
      async queryByPage() {
        this.listLoading = true // 开启加载动画
        findByIdBaoZhangDetails(this.org_ID).then(res => {
          console.log(res,'---res-----');
          
          if (res.code === 1 && res.data) {
            let data = res.data
            this.form = data.activityReimbursement || this.form
            this.tableData = data.auditList
            this.listLoading = false // 关闭加载动画
          }
        })
      },
      // 返回
      returnToLevel() {
        this.$router.push({ path: '/publicizeMaterialManagement/reimbursementLis'})
      }
    }
  }
  </script>
  
  <style scoped>
  .top-btn {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
  }
  .table-container {
    width: 100%;
    overflow-x: auto;
  }
  
  table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
  }
  
  th, td {
    border: 1px solid #ccc;
    padding: 8px;
    text-align: center;
    width: 170px;
  }
  .white-background {
    background-color: #fff;
  }
  .align-right {
    text-align: right;
  }
  .vxe-table--header th {
    background-color: #336699;
    color: #ffffff;
  }
  .note {
    margin-top: 10px;
    font-size: 12px;
    color: red;
  }
  </style>
  